/**
 * @param bundledWith THe MFE's metadata.bundledWith.
 * @param exposedInstanceDependencies The hosts's EXPOSED_INSTANCE_DEPENDENCIES, if any.
 * @returns Returns true when host and MFE use compatible version of LaunchDarkly
 * and returns false when host and MGE use incompatible version.
 * Returns undefined when either the host or MFE doesn't expose LaunchDarkly.
 */
export function getMFEHasCompatibleLaunchDarklyVersion(bundledWith, exposedInstanceDependencies) {
    var _a;
    const mfeVersion = bundledWith === null || bundledWith === void 0 ? void 0 : bundledWith['launchdarkly-js-client-sdk'];
    const hostVersion = (_a = exposedInstanceDependencies.launchDarkly) === null || _a === void 0 ? void 0 : _a.version;
    if (hostVersion && mfeVersion) {
        return hostVersion === mfeVersion;
    }
}
//# sourceMappingURL=get-mfe-has-compatible-launchdarkly-version.js.map